var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1114(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M301.199,844.313l617.02,0.22c0,0 215.535,-22.93 218.682,-235.431c3.312,-223.598 -231.682,-237.557 -238.018,-248.729c-47.064,-82.991 -79.06,-194.862 -285.443,-196.047c-255.638,-1.467 -292.041,299.04 -302.307,301.435c-77.27,18.029 -198.905,47.071 -197.612,205.962c1.296,159.255 187.678,172.59 187.678,172.59Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.729,449.656c-83.575,19.889 -204.306,56.497 -202.957,222.22c0.721,88.615 52.694,136.789 104.728,162.653c50.257,24.98 100.361,28.487 100.361,28.487c0.443,0.031 0.887,0.047 1.331,0.047l617.02,0.22c0.665,0 1.33,-0.035 1.991,-0.105c-0,-0 232.055,-24.852 235.446,-253.798c2.841,-191.826 -156.667,-240.822 -224.545,-258.462c-7.295,-1.895 -14.763,-3.952 -18.887,-5.106c-28.224,-50.893 -53.16,-110.457 -112.012,-151.274c-41.243,-28.603 -99.076,-48.459 -186.657,-48.961c-122.901,-0.706 -198.476,63.73 -245.316,135.264c-44.288,67.635 -62.218,141.592 -70.503,168.815Zm4.197,375.904c-5.382,-0.477 -45.484,-4.605 -85.734,-24.611c-41.48,-20.618 -83.346,-58.738 -83.921,-129.378c-1.188,-145.917 112.162,-170.993 183.122,-187.55c3.265,-0.762 7.345,-2.488 10.967,-6.965c1.375,-1.701 3.414,-5.042 5.249,-10.264c1.983,-5.643 4.654,-15.452 8.367,-28.196c21.467,-73.687 80.426,-256.627 273.356,-255.52c77.526,0.445 128.994,16.957 165.502,42.276c55.714,38.641 76.759,96.694 103.739,144.27c1.48,2.609 4.298,6.211 9.874,8.949c4.361,2.141 14.776,4.887 29.225,8.642c58.717,15.259 198.939,55.675 196.481,221.611c-2.789,188.337 -186.549,215.139 -201.016,216.957c-0.012,0.002 -615.171,-0.217 -615.171,-0.217l-0.04,-0.004Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M530.598,1009.36l-178.46,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.128,931.233l-89.23,154.551",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.983,1085.57l-89.23,-154.551",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M643.251,952.668l246.124,-0.136c9.198,-0.005 16.662,-7.477 16.657,-16.676c-0.005,-9.199 -7.477,-16.663 -16.676,-16.657l-246.123,0.136c-9.199,0.005 -16.663,7.477 -16.658,16.676c0.005,9.199 7.478,16.662 16.676,16.657Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M643.251,1039.32l194.927,-0.108c9.199,-0.005 16.663,-7.477 16.658,-16.676c-0.005,-9.199 -7.478,-16.663 -16.676,-16.657l-194.927,0.108c-9.199,0.005 -16.663,7.477 -16.658,16.676c0.005,9.198 7.478,16.662 16.676,16.657Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1114);
export default __webpack_public_path__ + "static/media/1114.ee35a3ec59100d7d5406e3fa15843b4c.svg";
export { ForwardRef as ReactComponent };